<template>
  <v-container class="nps-view" fill-height fluid>
    <page-title title="NPS Design"></page-title>
    <NpsQuestion
      v-if="view === routes.SURVEY_CUSTOMIZE_NPS_QUESTION"
      :color="currentCampaign.primary_color"
      :buttonShape="buttonShape"
      :brandName="currentCampaign.brand_name"
      :animationEnabled="currentCampaign.options.widget_settings.animation_enabled"
    >
      <template v-slot:question>
        <span class="design-label">
          Question: 
        </span>
        <span>{{ questionParts[0] }}</span>
        <input
          class="brand-title-input lgrm-box-input"
          type="text"
          disabled
          :style="brandTitleInputStyle"
          v-model="brandName"
        />
        <span>{{ questionParts[1] }}</span>
        <v-layout class="nps-button-shape" column>
          <div class="button-shape-label">Button Shape</div>
          <v-layout>
            <v-flex
              class="nps-shape square"
              :class="{
                selected: buttonShape === 'SQUARE'
              }"
              @click="saveShape('SQUARE')"
            >
              <div
                class="nps-shape-inner"
                :style="npsShapeSelectedColor('SQUARE')"
              ></div>
            </v-flex>
            <v-flex
              class="nps-shape circle"
              :class="{ selected: buttonShape === 'CIRCLE' }"
              @click="saveShape('CIRCLE')"
            >
              <div
                class="nps-shape-inner"
                :style="npsShapeSelectedColor('CIRCLE')"
              ></div>
            </v-flex>
          </v-layout>
        </v-layout>
      </template>
    </NpsQuestion>
    <DriversDesign
      v-if="view === routes.SURVEY_CUSTOMIZE_NPS_DRIVERS"
      :brandTitle="brandName"
      :question="currentQuestion"
      driver-status-label="Enable NPS driver question for"
      @change="$emit('saveQuestion', currentQuestion)"
    ></DriversDesign>
    <OpenendedDesign
      v-if="view === routes.SURVEY_CUSTOMIZE_NPS_OPEN_ENDED"
      :color="currentCampaign.primary_color"
      :brandTitle="brandName"
      :question="currentQuestion"
      @change="$emit('saveQuestion', currentQuestion)"
    ></OpenendedDesign>
  </v-container>
</template>

<script>
import routes from '@/route_names'
import strings from '@/strings'
import NpsQuestion from '../../../../../widgets/feedback/src/components/NpsQuestion'
import DriversDesign from '@/components/survey/DriversDesign.vue'
import OpenendedDesign from '@/components/survey/OpenendedDesign.vue'
import campaignApi from '@/api/campaign'
export default {
  name: 'NpsView',
  props: {
    view: String,
    campaign: {
      type: Object
    },
    questions: {
      type: Array
    }
  },
  components: {
    NpsQuestion,
    DriversDesign,
    OpenendedDesign
  },
  data: function() {
    return {
      route: this.$router.currentRoute.name,
      brandName: this.campaign.brand_name,
      currentCampaign: this.campaign,
      buttonShape: this.questions[0].options.button_shape
    }
  },
  computed: {
    routes: function() {
      return routes
    },
    questionParts: function() {
      if (this.currentQuestion) {
        return this.currentQuestion.question.split('{brand_name}')
      }

      return ['', '']
    },
    brandTitleInputStyle: function() {
      return {
        textAlign: 'center',
        width: this.brandName.length * 10 + 30 + 'px'
      }
    },
    currentQuestion: function() {
      let question = {}
      if (!this.questions) return question
      if (this.view === routes.SURVEY_CUSTOMIZE_NPS_QUESTION) {
        question = this.questions[0]
      }
      if (this.view === routes.SURVEY_CUSTOMIZE_NPS_DRIVERS) {
        question = this.questions[1]
      }
      if (this.view === routes.SURVEY_CUSTOMIZE_NPS_OPEN_ENDED) {
        question = this.questions[2]
      }
      console.log(question)
      return question
    }
  },
  watch: {},
  methods: {
    save(val) {
      console.log(this.brandName, val)
      this.$emit('save', this.campaign)
    },
    saveShape(shape) {
      this.buttonShape = shape
      this.questions[0].options.button_shape = shape
      campaignApi.updateQuestion(
        this.$router.currentRoute.params.campaignId,
        this.questions[0].id,
        this.questions[0]
      )
    },

    npsShapeSelectedColor: function(shape) {
      const sty = {}
      if (shape === this.buttonShape) {
        sty.borderColor = this.campaign.primary_color
        sty.background = this.campaign.primary_color
      }
      return sty
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.route = to.name
    next()
  }
}
</script>

<style lang="stylus">
.nps-view {
    .brand-title-input {
        min-width 50px
    }
    .button-shape-label {
        color: $color-primary-light-1
    }
    .nps-button-shape {
        position absolute
        right 0
        text-align left

        @media (max-width 700px) {
            display: none
        }


        .nps-shape {
            border: 1px solid $color-primary-light-8;
            box-sizing: border-box;
            border-radius: 3px
            width 50px
            height 50px
            display flex
            align-items center
            justify-content center
            margin-right 20px
            margin-top 5px
            cursor pointer
            transition all 500ms
            .nps-shape-inner {
                background: #F1F2F6;
                border: 1px solid #F1F2F6;
                box-sizing: border-box;
                height 35px
                width 35px
                transition all 500ms
            }
            &.square {
                .nps-shape-inner {
                    border-radius 3px
                }
            }
            &.circle {
                .nps-shape-inner {
                    border-radius 50%
                }
            }
            &.selected {
                border: 1px solid $color-primary-light-5;
                background: $color-primary-light-7;
            }
        }
    }
}
</style>
